import { render, staticRenderFns } from "./BackupAutomaticSwitcher.vue?vue&type=template&id=3fde6bad&scoped=true"
import script from "./BackupAutomaticSwitcher.vue?vue&type=script&lang=js"
export * from "./BackupAutomaticSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BackupAutomaticSwitcher.vue?vue&type=style&index=0&id=3fde6bad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fde6bad",
  null
  
)

export default component.exports